import type { ColumnDef } from '@tanstack/react-table';
import { EmptyValue } from '@/components/common/EmptyValue';
import { formatNumber } from '@/utils/number';
import type { OfflineDcrRow } from '../types/billing.types';

export function getQtyColumn(): ColumnDef<OfflineDcrRow, unknown> {
  return {
    id: 'qty',
    header: 'Qty',
    cell: ({ row }) =>
      row.original.qtyTotal > 0 ? (
        <span className="tabular-nums">{formatNumber(row.original.qtyTotal)}</span>
      ) : (
        <EmptyValue />
      ),
  };
}
